import { render, staticRenderFns } from "./PagesTab.vue?vue&type=template&id=5b3120aa&"
import script from "./PagesTab.vue?vue&type=script&lang=js&"
export * from "./PagesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports